import React, { useState } from 'react';
import { useLanguage } from '../../helpers/language-context';

const ApplicationModal = ({ job, onClose, onSubmit, isSubmitting }) => {
  const { translations } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    resumeUrl: '',
    linkedinUrl: '',
    messageToHirer: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center sticky top-0 bg-white">
          <h2 className="text-xl font-bold text-[#28357B]">
            {translations?.careerForm?.title || 'Apply for'} {job.title}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="M6 18L18 6M6 6l12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{translations?.careerForm?.fullName || 'Full Name'} <span className="text-red-500">*</span></label>
            <input
              required
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#28357B]"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{translations?.careerForm?.email || 'Email'} <span className="text-red-500">*</span></label>
            <input
              required
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#28357B]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{translations?.careerForm?.phone || 'Phone'} <span className="text-red-500">*</span></label>
            <input
              required
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#28357B]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{translations?.careerForm?.resumeUrl || 'Resume / CV URL'} <span className="text-red-500">*</span></label>
            <input
              required
              type="url"
              name="resumeUrl"
              placeholder="Link to Google Drive, Dropbox, etc."
              value={formData.resumeUrl}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#28357B]"
            />
            <p className="text-xs text-gray-500 mt-1">{translations?.careerForm?.resumeHint || 'Please provide a accessible link to your resume.'}</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{translations?.careerForm?.linkedin || 'LinkedIn Profile'}</label>
            <input
              type="url"
              name="linkedinUrl"
              value={formData.linkedinUrl}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#28357B]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{translations?.careerForm?.message || 'Message to Hirer / Cover Letter'}</label>
            <textarea
              name="messageToHirer"
              rows="4"
              value={formData.messageToHirer}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#28357B]"
            />
          </div>

          <div className="pt-4 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md"
            >
              {translations?.careerForm?.cancel || 'Cancel'}
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 bg-[#28357B] text-white rounded-md hover:bg-[#1e2a69] disabled:opacity-50"
            >
              {isSubmitting ? (translations?.careerForm?.submitting || 'Submitting...') : (translations?.careerForm?.submit || 'Submit Application')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApplicationModal;
